import { defineComponent as _defineComponent } from 'vue'
import './styles/action-bar.scss';
import { V2Device } from 'ctp-search-device';
import { useI18n } from 'vue-i18n-composable';
import { computed, PropType, ref, watch } from 'vue';
import useStore from '@/utils/store/common';


export default /*#__PURE__*/_defineComponent({
  __name: 'ActionBar',
  props: {
  label: {
    type: String,
    default: ''
  },
  isActionBarOpen: Boolean,
  fluid: Boolean,
  actions: {
    type: Array as PropType<string[]>,
    default: [] as string[]
  },
  hasSeveralMasterAccounts: Boolean
},
  setup(__props) {

const props = __props;



const { t } = useI18n();

const store = useStore();

const tActions = computed(() => props.actions.map((s: string) => t(s)));

const getDevicesList = computed(() => store.getters['devices/getDevicesList']);

const getUserSelectionDevices = computed(() => store.getters['devices/getUserSelectionDevices']);

const isOpen = ref(false);

const actionSelected = ref('');

const actionDisabled = ref(false);

const errorMessage = ref('');

/**
   * Disable save button on conditions:
   * Update status: Selected devices should have the same type & same status
   * Reboot device: Only 1 OBU device can be rebooted
   * Sets a message in each error case
   */
function actionForbidden() {
  const selectedDevices = getDevicesList.value.filter((device: V2Device) => getUserSelectionDevices.value.includes(device.id!.toString()));
  const selectedDevicesTypes = selectedDevices.map((device: V2Device) => device.type);
  const distinctTypes = [...new Set(selectedDevicesTypes)];
  if (distinctTypes.length > 1) {
    errorMessage.value = t('device.update.notification.no_action_different_types').toString();
  } else if (selectedDevices.length > 1 && actionSelected.value === t('device.actions.reboot_device')) {
    errorMessage.value = t('device.update.notification.no_reboot_single').toString();
  } else {
    errorMessage.value = '';
  }
  actionDisabled.value = errorMessage.value !== '';
}

const actionBarClasses = computed(() => `${props.fluid ? 'fluid-action-bar' : ''}`);

const disableSubscribe = computed(() => props.hasSeveralMasterAccounts && actionSelected.value === t('device.subscription.title').toString());

const disabled = computed(() => disableSubscribe.value || !actionSelected.value || actionDisabled.value);

watch(
  getUserSelectionDevices,
  () => actionForbidden(),
  { deep: true }
);

watch(
  () => actionSelected.value,
  () => actionForbidden()
);

watch(
  () => props.isActionBarOpen,
  () => {
    isOpen.value = props.isActionBarOpen;
    actionSelected.value = '';
  }
);

watch(
  () => props.actions,
  () => { actionSelected.value = ''; }
);


return { __sfc: true,props, t, store, tActions, getDevicesList, getUserSelectionDevices, isOpen, actionSelected, actionDisabled, errorMessage, actionForbidden, actionBarClasses, disableSubscribe, disabled }
}

})